import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import brandInstagramBusinessAccountUpdaters, {
  type UpdateBrandInstagramBusinessAccountParams,
} from '@/api/updaters/brandInstagramBusinessAccount';

function useUpdateBrandInstagramBusinessAccount() {
  return useMutation({
    mutationKey: ['brandInstagramBusinessAccount', 'updateAdsAccountId'],
    mutationFn: ({
      brandId,
      brandInstagramBusinessAccountId,
      adsAccountId,
    }: UpdateBrandInstagramBusinessAccountParams) =>
      brandInstagramBusinessAccountUpdaters.updateAdsAccountId({
        brandId,
        brandInstagramBusinessAccountId,
        adsAccountId,
      }),
    onSuccess: (_data, variables) => {
      if (variables.brandId) {
        queryClient.invalidateQueries(['agency', variables.brandId]);
      }
    },
  });
}

export default useUpdateBrandInstagramBusinessAccount;
